module.exports = __webpack_public_path__ + "static/assets/c9d84b12f7e6a5a4547c8672d827b703.png";